"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SalesDashboardComparatorItem_1 = require("../model/SalesDashboardComparatorItem");

var DashboardPromoType_1 = require("../sales-dashboard/DashboardPromoType");

var SalesDashboardComparatorItemConverter_1 = require("./SalesDashboardComparatorItemConverter");
/**
 * @author Radim Krkoška
 */


var SalesDashboardComparatorItemConverterImpl =
/*#__PURE__*/
function (_SalesDashboardCompar) {
  _inherits(SalesDashboardComparatorItemConverterImpl, _SalesDashboardCompar);

  function SalesDashboardComparatorItemConverterImpl() {
    _classCallCheck(this, SalesDashboardComparatorItemConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardComparatorItemConverterImpl).apply(this, arguments));
  }

  _createClass(SalesDashboardComparatorItemConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SalesDashboardComparatorItem_1.SalesDashboardComparatorItem(SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.volumeDiff.valueOf(conversions.toBigNumber(source.volumeDiff)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.costValueDiff.valueOf(conversions.toBigNumber(source.costValueDiff)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.title.valueOf(source.title), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.promoType.valueOf(conversions.asEnum(source.promoType, DashboardPromoType_1.DashboardPromoType)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.simulation.valueOf(source.simulation), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.volumeSDR.valueOf(conversions.toBigNumber(source.volumeSDR)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.volumePPR.valueOf(conversions.toBigNumber(source.volumePPR)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.costValueSDR.valueOf(conversions.toBigNumber(source.costValueSDR)), SalesDashboardComparatorItem_1.SalesDashboardComparatorItem.schema.costValuePPR.valueOf(conversions.toBigNumber(source.costValuePPR)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        volumeDiff: conversions.fromBigNumber(source.volumeDiff),
        costValueDiff: conversions.fromBigNumber(source.costValueDiff),
        title: source.title,
        promoType: source.promoType,
        simulation: source.simulation,
        volumeSDR: conversions.fromBigNumber(source.volumeSDR),
        volumePPR: conversions.fromBigNumber(source.volumePPR),
        costValueSDR: conversions.fromBigNumber(source.costValueSDR),
        costValuePPR: conversions.fromBigNumber(source.costValuePPR)
      });
      return result;
    }
  }]);

  return SalesDashboardComparatorItemConverterImpl;
}(SalesDashboardComparatorItemConverter_1.SalesDashboardComparatorItemConverter);

exports.SalesDashboardComparatorItemConverterImpl = SalesDashboardComparatorItemConverterImpl;